import React from 'react';
import { HostAppShell } from '../components/HostAppShell';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, BarChart3, Sparkles, Megaphone, HeadphonesIcon, ShieldPlus } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const FEATURE_PAGES = {
  gps: { title: 'GPS Tracking', icon: MapPin, desc: 'Real-time GPS tracking for all active trips.', activeId: 'gps_tracking' },
  boost: { title: 'Boost Listing', icon: Megaphone, desc: 'Increase your vehicle visibility in search results.', activeId: 'boost_listing' },
  'ai-assistant': { title: 'AI Assistant', icon: Sparkles, desc: 'AI-powered pricing suggestions and fleet optimisation.', activeId: 'ai_assistant' },
  'priority-support': { title: 'Priority Support', icon: HeadphonesIcon, desc: 'Get faster response times from our support team.', activeId: 'priority_support' },
  'insurance-perks': { title: 'Insurance Perks', icon: ShieldPlus, desc: 'Enhanced insurance coverage and premium claim support.', activeId: 'insurance_perks' },
};

const HostFeaturePlaceholder = ({ featureKey }) => {
  const config = FEATURE_PAGES[featureKey] || FEATURE_PAGES.gps;
  const Icon = config.icon;
  
  return (
    <HostAppShell title={config.title} activeId={config.activeId}>
      <div className="max-w-2xl mx-auto py-12">
        <Card className="border-dashed border-slate-300" data-testid={`feature-placeholder-${featureKey}`}>
          <CardContent className="p-8 text-center space-y-4">
            <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto">
              <Icon className="w-7 h-7 text-slate-400" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-slate-900">{config.title}</h2>
              <p className="text-sm text-slate-500 mt-1">{config.desc}</p>
            </div>
            <Badge variant="outline" className="text-xs text-slate-400 border-slate-200">
              Coming Soon
            </Badge>
            <p className="text-xs text-slate-400">
              This feature is included in your plan and will be available soon.
            </p>
          </CardContent>
        </Card>
      </div>
    </HostAppShell>
  );
};

export default HostFeaturePlaceholder;
